"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _imutils = require("@tencent/imutils");

var _CountDown = _interopRequireDefault(require("../../utils/CountDown"));

require("./index.scss");

const TIMER_COUNT = 60;

class VerifyCodeBtn extends _react.default.PureComponent {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      isCounting: null,
      remainSec: TIMER_COUNT
    });
    (0, _defineProperty2.default)(this, "onBtnClick", async e => {
      const _this$props = this.props,
            onClick = _this$props.onClick,
            enable = _this$props.enable,
            countDownSec = _this$props.countDownSec;
      const isCounting = this.state.isCounting; // disable click

      if (!enable || isCounting) {
        return;
      } // 阻止document原生click事件，和外层点击focus事件


      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();

      try {
        await onClick(e);
        this.setState({
          remainSec: countDownSec,
          isCounting: true
        });
        this.countDown();
      } catch (err) {
        console.error(err);
      }
    });
  }

  // 开始倒计时
  countDown() {
    const isCounting = this.state.isCounting,
          _this$props2 = this.props,
          countDownSec = _this$props2.countDownSec,
          onCountChange = _this$props2.onCountChange; // isCounting：接口响应成功，开始倒计时

    const countDownIns = new _CountDown.default({
      onCountChange: remainSec => {
        if (remainSec > 1) {
          this.setState({
            remainSec
          });

          if (typeof onCountChange === 'function') {
            onCountChange(remainSec);
          }
        } else {
          this.setState({
            isCounting: false
          });
        }
      }
    });

    if (isCounting) {
      countDownIns.start();
    } else {
      countDownIns.clear();
    }
  }

  createText() {
    const _this$state = this.state,
          isCounting = _this$state.isCounting,
          remainSec = _this$state.remainSec;
    return isCounting ? `${remainSec}s后重发` : '发送验证码';
  }

  render() {
    const onBtnClick = this.onBtnClick,
          _this$props3 = this.props,
          className = _this$props3.className,
          enable = _this$props3.enable,
          isCounting = this.state.isCounting;
    const cls = (0, _classnames.default)('get-code-btn', className, {
      disable: !enable,
      sending: isCounting
    });
    return /*#__PURE__*/_react.default.createElement("button", {
      "data-modid": "sms_verification",
      className: cls,
      onClick: e => {
        _imutils.tdwReport.report({
          event: 'click',
          module: 'sms_verification' // 事件名

        });

        onBtnClick(e);
      }
    }, this.createText());
  }

}

(0, _defineProperty2.default)(VerifyCodeBtn, "defaultProps", {
  className: '',
  onClick: () => {},
  onCountChange: () => {},
  enable: false,
  countDownSec: TIMER_COUNT
});
var _default = VerifyCodeBtn;
exports.default = _default;